function loadHotelLogo(logoUrlTmpl, headerImageId, headerImageMobileId) {
	// eslint-disable-line no-unused-vars
	if ($('img[name=header-image]').length > 0) {
		var surveyLogo = $('img[name=header-image]');
		surveyLogo.attr('src', logoUrlTmpl.replace('{logo_id}', headerImageId));
	}

	if ($('img[name=header-image-mobile]').length > 0) {
		var _surveyLogo = $('img[name=header-image-mobile]');
		_surveyLogo.attr('src', logoUrlTmpl.replace('{logo_id}', headerImageMobileId));
	}

	// Wait for mobile banner image to load in order to set height of mobile banner div
	if (headerImageMobileId) {
		var img = new Image();
		// let imgHeight;

		// img.onload = function () {
		// 	// cap the mobile header banner to the max container width
		// 	imgHeight = img.width > 860 ? Math.round(img.height * 860 / img.width) : img.height;
		// 	$('.header-banner-mobile').height(imgHeight);
		// };
		img.src = logoUrlTmpl.replace('{logo_id}', headerImageMobileId);
	}
}